import React, { useMemo } from 'react';

import { useEtimTranslation } from '../../../../use/etim-translation';
import { DangerousHTML } from '../../../../components/DangerousHTML';
import { LocalizedFilterText } from '../../../../components/LocalizedFilterText';
import { Tooltip } from '../../../../components/Tooltip';

interface ProductTableCellContentProps {
  value: string;
  translateEtimValue: ((s: string) => string) | undefined;
}

const showValueTooltip = theme.featureFlags.etimValueTooltips;

const ProductTableCellContent: React.FC<ProductTableCellContentProps> = ({ value, translateEtimValue }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const valueTooltipData = showValueTooltip ? useEtimTranslation(value) : {};

  const valueContent = useMemo(() => {
    return <LocalizedFilterText value={value} attribute="" translateEtimValue={translateEtimValue} />;
  }, [value, translateEtimValue]);

  if (valueTooltipData.tooltip) {
    return (
      <Tooltip tooltipAnchor={valueContent} tooltipContent={<DangerousHTML content={valueTooltipData.tooltip} />} />
    );
  }

  return valueContent;
};

export { ProductTableCellContent };
